import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";
import { usePagination } from "@/utils/stores/pagination";
import { useFiltering } from "@/utils/stores/filtering";

const storeName = "purchaseAgreement";

export const usePurchaseAgreementStore = defineStore(storeName, () => {
  const all = ref([]);

  const searchQuery = ref(null);

  const { sortedResources } = useFiltering(all, searchQuery, "id");
  const { paginatedResources, goToPage, goToNextPage, goToPreviousPage, paginationRange, totalPages, currentPage } = usePagination(sortedResources, 10);
  const { baseFetchOne, baseDelete, baseMultipartSave } = useBase(storeName);

  const empty = {};

  const save = async (resource, saleListingAgreementId, purchaseOfferId, callback, errorCallback) => {
    const path = `sale-listing-agreements/${saleListingAgreementId}/purchase-offers/${purchaseOfferId}/purchase-agreements`;
    return await baseMultipartSave(path, resource, callback, errorCallback);
  };

  const fetchOne = async (id, saleListingAgreementId, purchaseOfferId, errorCallback) => {
    const path = `sale-listing-agreements/${saleListingAgreementId}/purchase-offers/${purchaseOfferId}/purchase-agreements`;
    return await baseFetchOne(path, id, errorCallback);
  };

  const destroy = async (id, saleListingAgreementId, purchaseOfferId, errorCallback) => {
    const path = `sale-listing-agreements/${saleListingAgreementId}/purchase-offers/${purchaseOfferId}/purchase-agreements`;
    return await baseDelete(path, id, null, errorCallback);
  };

  return {
    all,
    currentPage,
    empty,
    fetchOne,
    goToNextPage,
    goToPage,
    goToPreviousPage,
    paginated: paginatedResources,
    paginationRange,
    save,
    destroy,
    searchQuery,
    sorted: sortedResources,
    totalPages,
  };
});
